export default __webpack_public_path__ + "static/media/logo-deskphone.cd05d6f7.png";